import { Button, IconButton, Select, TextField } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { ReactComponent as SearchIcon } from '../../../assets/images/Search.svg';
import DoneIcon from '@mui/icons-material/Done';
import userProfile from '../../../assets/images/userProfile.svg';
import { ExpandMore } from '@mui/icons-material';
import { useSelector } from 'react-redux';
import { useHook as DealerManagementHook } from '../Iam/dealerManagement/useHook';
interface AssignDrawer {
  assignCloseDrawer: () => void;
  assignSubmit: (data: any) => void;
  unitData:any
}
interface UserDataList {
  dealerID: string;
  userName: string;
  firstName: string;
  lastName: string;
  avatar: string;
}

const AssignUserDrawer: React.FC<AssignDrawer> = ({
  assignCloseDrawer,
  assignSubmit,
  unitData
}) => {
  const [assignDealer, setAssignDealer] = useState<any[]>([]);
  const [filteredData, setFilteredData] = useState<UserDataList[]>([]);
  const [selectedusername, setSelectedusername] = useState<any>(null);
  const { allAssignDealerList } = useSelector((state: any) => state.dealer);
  const [openUser, setOpenUser] = useState(false);
  const { fetchGetAllAssignDealerList } = DealerManagementHook();
  const getUserData = async () => {
    await fetchGetAllAssignDealerList({});
  };
useEffect(() => {
 
  if (unitData?.dealerID) {
    const assignedDealerData = allAssignDealerList.find(
      (dealer: any) => dealer.dealerID === unitData.dealerID
    );

    setSelectedusername(assignedDealerData);
    setAssignDealer(assignedDealerData ? [assignedDealerData] : []); // ✅ now it's always an array
  }
}, [unitData, allAssignDealerList]);

  
  useEffect(() => {
    setFilteredData(allAssignDealerList);
  }, [allAssignDealerList]);

  useEffect(() => {
    getUserData();
  }, []);

  const handleUserSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const query: string = event.target.value.toLowerCase();
    const filtered: UserDataList[] = allAssignDealerList?.filter(
      (user: { firstName: any; lastName: any }) =>
        `${user.firstName + user.lastName}`.toLowerCase().includes(query),
    );
    setFilteredData(filtered);
  };

  const handleuser = (userData: any): void => {
    if (userData) {
      setSelectedusername(userData);
      setAssignDealer([userData]);
    } else {
      setSelectedusername(null);
    }
    setOpenUser(false), setFilteredData(allAssignDealerList);
  };
  return (
    <>
      <div className="fliter-drawer-container">
        <div>
          <div className="fliter-drawer-header">
            <p className="fliter-drawer-header-content">Assign Dealer</p>
          </div>

          <div className="fliter-drawer-body">
            <div className="drawer_selecte-div">
              <h6 className="drawer_selecte_content">Dealer</h6>
              <Select
                open={openUser}
                onOpen={() => setOpenUser(true)}
                onClose={() => {
                  setOpenUser(false), setFilteredData(allAssignDealerList);
                }}
                className="drawer_input_select"
                multiple
                displayEmpty
                value={assignDealer}
                renderValue={() => (
                  <div className="selecter_dropdown_placeholder">
                    {!selectedusername ? (
                      'Select Dealer'
                    ) : (
                      <div className="global_audilog_user_profile_cheked">
                        <img
                          src={
                            selectedusername?.avatar
                              ? selectedusername?.avatar
                              : userProfile
                          }
                          width={24}
                          alt="User Profile"
                        />{' '}
                        <p>{`${selectedusername?.firstName} ${selectedusername?.lastName}`}</p>
                      </div>
                    )}
                  </div>
                )}
                IconComponent={ExpandMore}
              >
                <div className="user_name-popover">
                  <div className="user_name-popover-search">
                    <TextField
                      className="user_name-popover-search_input search-input"
                      variant="outlined"
                      placeholder="Search Dealer"
                      fullWidth
                      InputProps={{
                        startAdornment: <SearchIcon className="search_icon" />,
                      }}
                      onChange={handleUserSearch}
                    />
                  </div>
                  {filteredData.map((user, index) => (
                    
                    <Button
                      key={index}
                      onClick={() => {
                        handleuser(user);
                      }}
                      className={
                        selectedusername?.dealerID === user?.dealerID
                          ? 'global_audilog_user user_checked'
                          : 'global_audilog_user'
                      }
                    >
                      <div className="global_audilog_user_profile">
                        <img
                          src={user?.avatar ? user?.avatar : userProfile}
                          width={24}
                          alt="User Profile"
                        />{' '}
                        <p>{`${user?.firstName} ${user?.lastName}`}</p>
                      </div>
                      {selectedusername?.dealerID === user?.dealerID && (
                        <IconButton className="iconButton">
                          <DoneIcon className="doneIcon" />
                        </IconButton>
                      )}
                    </Button>
                  ))}
                </div>
              </Select>
            </div>
          </div>
        </div>

        <div className="create_controller-nodata_drawer_button_content">
          <div className="create_controller-nodata_drawer_button">
            <Button
              variant="text"
              className="cencel_button"
              onClick={assignCloseDrawer}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              className={
                selectedusername ? 'save_button' : 'save_button disabled_button'
              }
              disabled={!selectedusername}
              onClick={() => assignSubmit(selectedusername)}
            >
              Update
            </Button>
          </div>
        </div>
      </div>
    </>
  );
};

const MemoizedComponent = React.memo(AssignUserDrawer);
export default MemoizedComponent;
